import React, { useState } from "react";

export default function KartSimulation() {
  const [formData, setFormData] = useState({
    LapsPrev: 9,
    LapsNext: 9,
    AmbientTempPrev: 20,
    AmbientTempNext: 20,
    ColdTempFL: '', ColdTempFR: '', ColdTempRL: '', ColdTempRR: '',
    HotPressureFL: '', HotPressureFR: '', HotPressureRL: '', HotPressureRR: '',
    EstimatedColdPressureFL: '', EstimatedColdPressureFR: '',
    EstimatedColdPressureRL: '', EstimatedColdPressureRR: '',
    ColdTempFLNext: '', ColdTempFRNext: '', ColdTempRLNext: '', ColdTempRRNext: '',
    HotPressureFLNext: '', HotPressureFRNext: '', HotPressureRLNext: '', HotPressureRRNext: '',
    AchievedHotPressureFL: '', AchievedHotPressureFR: '',
    AchievedHotPressureRL: '', AchievedHotPressureRR: ''
  });

  const [results, setResults] = useState({
    EstimatedHotTempFLNext: '', EstimatedHotTempFRNext: '',
    EstimatedHotTempRLNext: '', EstimatedHotTempRRNext: '',
    EstimatedHotPressureFLNext: '', EstimatedHotPressureFRNext: '',
    EstimatedHotPressureRLNext: '', EstimatedHotPressureRRNext: '',
    EstimatedColdPressureFLNext: '', EstimatedColdPressureFRNext: '',
    EstimatedColdPressureRLNext: '', EstimatedColdPressureRRNext: '',
  });

  const handleChange = (e) => {
    let value = e.target.value;

    // Convert to number if valid, otherwise default to 0
    if (value === "") {
      value = "";
    } else {
      value = parseFloat(value);
    }
  
    // Update state
    setFormData({ ...formData, [e.target.name]: value });
  };

  const handleSubmit = async () => {
    console.log("🚀 Sending Data to Backend:", formData);

    try {
      const API_URL = process.env.REACT_APP_API_URL || "https://kartingpressureapp.onrender.com";

      const response = await fetch(`${API_URL}/simulate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const data = await response.json();
      console.log("✅ Received Data from Backend:", data);
      setResults(data);
    } catch (error) {
      console.error("❌ API Call Failed:", error);
    }
  };

  const handleSaveToServer = async () => {
    try {
      if (
        formData.AchievedHotPressureFL === '' ||
        formData.AchievedHotPressureFR === '' ||
        formData.AchievedHotPressureRL === '' ||
        formData.AchievedHotPressureRR === ''
      ) {
        throw new Error("❌ All Achieved Hot Pressures must be filled before saving!");
      }
      const API_URL = process.env.REACT_APP_API_URL || "https://kartingpressureapp.onrender.com";
  
      const response = await fetch(`${API_URL}/save-run`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ formData, results }),
      });
  
      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }
      // ✅ Receive the updated data from the backend
    const updatedData = await response.json();

    // ✅ Update React state with new values
    setFormData(updatedData.formData);
    setResults(updatedData.results);
  
      console.log("✅ Data saved successfully!");
    } catch (error) {
      console.error("❌ Failed to save data:", error);
    }
  };
  

  const renderMatrixOld = (fieldPrefix, isReadOnly = false, isNextRun = false) => (
    <div className="grid grid-cols-2 gap-2">
      <input type="number" name={`${fieldPrefix}FL${isNextRun ? "Next" : ""}`} placeholder="FL"
        value={isReadOnly ? results[`${fieldPrefix}FLNext`] ?? 0 : formData[`${fieldPrefix}FL${isNextRun ? "Next" : ""}`] ?? 0} 
        onChange={handleChange} className={`border p-2 w-full text-center ${isReadOnly ? "bg-gray-200" : ""} ${fieldPrefix === "EstimatedColdPressure" && isNextRun ? "font-bold text-red-600" : ""}`} 
        readOnly={isReadOnly} />
      <input type="number" name={`${fieldPrefix}FR${isNextRun ? "Next" : ""}`} placeholder="FR"
        value={isReadOnly ? results[`${fieldPrefix}FRNext`] ?? 0 : formData[`${fieldPrefix}FR${isNextRun ? "Next" : ""}`] ?? 0} 
        onChange={handleChange} className={`border p-2 w-full text-center ${isReadOnly ? "bg-gray-200" : ""} ${fieldPrefix === "EstimatedColdPressure" && isNextRun ? "font-bold text-red-600" : ""}`} 
        readOnly={isReadOnly} />
      <input type="number" name={`${fieldPrefix}RL${isNextRun ? "Next" : ""}`} placeholder="RL"
        value={isReadOnly ? results[`${fieldPrefix}RLNext`] ?? 0 : formData[`${fieldPrefix}RL${isNextRun ? "Next" : ""}`] ?? 0} 
        onChange={handleChange} className={`border p-2 w-full text-center ${isReadOnly ? "bg-gray-200" : ""} ${fieldPrefix === "EstimatedColdPressure" && isNextRun ? "font-bold text-red-600" : ""}`} 
        readOnly={isReadOnly} />
      <input type="number" name={`${fieldPrefix}RR${isNextRun ? "Next" : ""}`} placeholder="RR"
        value={isReadOnly ? results[`${fieldPrefix}RRNext`] ?? 0 : formData[`${fieldPrefix}RR${isNextRun ? "Next" : ""}`] ?? 0} 
        onChange={handleChange} className={`border p-2 w-full text-center ${isReadOnly ? "bg-gray-200" : ""} ${fieldPrefix === "EstimatedColdPressure" && isNextRun ? "font-bold text-red-600" : ""}`} 
        readOnly={isReadOnly} />
    </div>
  );

  const renderMatrix = (fieldPrefix, tooltipText, isReadOnly = false, isNextRun = false) => {
    const corners = { FL: "Front Left", FR: "Front Right", RL: "Rear Left", RR: "Rear Right" };
  
    return (
      <div className="grid grid-cols-2 gap-2">
        {Object.keys(corners).map(corner => (
          <input 
            key={corner}
            type="number"
            name={`${fieldPrefix}${corner}${isNextRun ? "Next" : ""}`} 
            placeholder={corner}
            value={isReadOnly ? results[`${fieldPrefix}${corner}Next`] ?? 0 : formData[`${fieldPrefix}${corner}${isNextRun ? "Next" : ""}`] ?? 0} 
            onChange={handleChange} 
            className={`border p-2 w-full text-center ${isReadOnly ? "bg-gray-200" : ""} ${fieldPrefix === "EstimatedColdPressure" && isNextRun ? "font-bold text-red-600" : ""}`} 
            readOnly={isReadOnly}
            title={`(${corners[corner]}) ${tooltipText}`} // Dynamically append corner name
          />
        ))}
      </div>
    );
  };
  

  return (
    <div className="p-4 max-w-4xl mx-auto bg-gray-100 shadow-lg rounded-lg">
      <h1 className="text-lg font-bold text-center">Cold Pressure Estimator
      <span className="text-gray-500 text-m ml-2 cursor-pointer" title="Enter values for your previous run, adjust conditions for the next run, and the tool will estimate the required cold pressures to achieve your desired hot pressures.">ⓘ</span>
      </h1>

      {/* Previous Run Panel */}
      <div className="border p-4 mb-4">
        <h3 className="font-semibold">Previous Run</h3>
        <div className="grid grid-cols-2 gap-2">
          <label>Laps:</label>
          <input type="number" name="LapsPrev" value={formData.LapsPrev} onChange={handleChange} className="border p-2 w-full" title="Number of laps completed in the previous run" />
          <label>Ambient Temp [°C]:</label>
          <input type="number" name="AmbientTempPrev" value={formData.AmbientTempPrev} onChange={handleChange} className="border p-2 w-full" title="Ambient temperature during the previous run"/>
        </div>

        {/*<div className="grid grid-cols-3 gap-4 mt-4">
          <div><h4 className="font-semibold text-center">Cold Temp [C]</h4>{renderMatrix("ColdTemp")}</div>
          <div><h4 className="font-semibold text-center">Cold P [psi]</h4>{renderMatrix("EstimatedColdPressure")}</div>
          <div><h4 className="font-semibold text-center">Hot P [psi]</h4>{renderMatrix("HotPressure")}</div>
           <div><h4 className="font-semibold text-center">(Est. HOT T [C])</h4>{renderMatrix("EstimatedHotTemp", true)}</div>
        </div>*/}
        <div className="grid grid-cols-2 gap-4 mt-4">
          {/* First row with 2 columns */}
          <div><h4 className="font-semibold text-center">Cold Temp [°C]</h4>{renderMatrix("ColdTemp","Cold Temperature before the run")}</div>
          <div><h4 className="font-semibold text-center">Cold P [psi]</h4>{renderMatrix("EstimatedColdPressure", "Cold Pressure before the run")}</div>

          {/* Second row spanning across both columns */}
          <div className="col-span-2"><h4 className="font-semibold text-center">Hot P [psi]</h4>{renderMatrix("HotPressure", "Hot Pressure after the run")}</div>
        </div>
      </div>

      {/* Next Run Panel */}
      <div className="border p-4">
        <h3 className="font-semibold">Next Run</h3>
        <div className="grid grid-cols-2 gap-2">
          <label>Laps:</label>
          <input type="number" name="LapsNext" value={formData.LapsNext} onChange={handleChange} className="border p-2 w-full" title="Expected number of laps for the next run"/>
          <label>Ambient Temp [°C]:</label>
          <input type="number" name="AmbientTempNext" value={formData.AmbientTempNext} onChange={handleChange} className="border p-2 w-full" title="Expected ambient temperature for the next run" />
        </div>

        <div className="grid grid-cols-2 gap-4 mt-4 items-end">
          <div className="flex flex-col items-center"><h4 className="font-semibold text-center">Cold Temp [°C]</h4>{renderMatrix("ColdTemp", "Cold Temperature before the run", false, true)}</div>
          <div className="flex flex-col items-center"><h4 className="font-semibold text-center">Target HOT P [psi]</h4>{renderMatrix("HotPressure", "Desired Hot Pressure after the run", false, true)}</div>
          {/* <div><h4 className="font-semibold text-center">(Est. HOT T [C])</h4>{renderMatrix("EstimatedHotTemp", true, true)}</div>*/}
          {/* <div><h4 className="font-semibold text-center">(Est. HOT P [psi])</h4>{renderMatrix("EstimatedHotPressure", true, true)}</div>*/}
        </div>
      </div>

      {/* Cold Pressure Output */}
      <div className="mt-4 border p-4">
        <h3 className="font-semibold text-center">COLD P [psi]</h3>
        {renderMatrix("EstimatedColdPressure", "Cold Pressure needed to achieve target hot pressure", true, true)}
      </div>

      {/* Calculate Button */}
      <button className="bg-green-500 text-white px-4 py-2 mt-4 w-full" onClick={handleSubmit}>
        Calculate
      </button>

      {/* Achieved Hot Pressures */}
      <div className="mt-4 border p-4">
        <h3 className="font-semibold text-center">Achieved Hot Pressures [psi]</h3>
        {renderMatrix("AchievedHotPressure", "Hot Pressure measured after the run", false, false)}
      </div>

      {/* Use for Next Run Button */}
      <div className="mt-4">
        <button onClick={handleSaveToServer} className="bg-blue-500 text-white px-4 py-2 mt-4 w-full">Use for Next Run</button>
      </div>
    </div>
  );
}
